// @flow
import React from 'react';
import Button from '@material-ui/core/Button';
import { Link } from 'gatsby';
import cx from 'classnames';
import styles from './PressKit.module.scss';

export default () => (
  <section className={cx(styles.register, styles.bottomBg)}>
    <div className={styles.registerWrapper}>
      <div className={styles.title}>
        Paidyのロゴや
        <br />
        会社案内をダウンロード
      </div>
      <Button
        variant="text"
        className="btn charcoal"
        component={Link}
        to="/press_kit/"
        target="_blank"
      >
        プレスキットはこちら
      </Button>
    </div>
  </section>
);
